import { Injectable } from '@angular/core'
import { BehaviorSubject } from 'rxjs'
import { IncentiveFamily } from '../enums/incentive.family'

@Injectable({
  providedIn: 'root'
})
export class IncentiveFamilyService {

  private readonly storageKey = 'incentiveFamily'

  readonly families = [
    {
      id: IncentiveFamily.RDTAX,
      label: 'Expenditure-based tax incentives',
      shortLabel: 'Expenditure-based',
      page: 'XBTI'
    },
    {
      id: IncentiveFamily.IPTAX,
      label: 'Income-based tax incentives',
      shortLabel: 'Income-based',
      page: 'IBTI'
    }
  ]

  private readonly familySubject = new BehaviorSubject<IncentiveFamily>(
    this.getInitialFamily()
  )

  readonly family$ = this.familySubject.asObservable()

  setFamily(family: IncentiveFamily): void {
    this.familySubject.next(family)
    localStorage.setItem(this.storageKey, family)
  }

  setFamilyByType(familyType: string): void {
    this.setFamily(this.families.find(family => family.shortLabel === familyType).id);
  }

  getPageByType(familyType: string): string {
    return this.families.find(family => family.shortLabel === familyType).page;
  }

  get family(): IncentiveFamily {
    return this.familySubject.value
  }

  private getInitialFamily(): IncentiveFamily {
    const storedFamily = localStorage.getItem(this.storageKey)

    if (
      storedFamily === IncentiveFamily.RDTAX ||
      storedFamily === IncentiveFamily.IPTAX
    ) {
      return storedFamily
    }

    return IncentiveFamily.RDTAX
  }
}
